exports.GenericDateErrors = {
  START_BEFORE_END_DATE:
    'The {page} start date must be before the {page} end date.',
  MISSING_DATES: 'The {page} Dates must be populated.',
  MISSING_START_DATE: 'The {page} start date must be populated.',
  MISSING_END_DATE: 'The {page} end date must be populated.',
  DIFFERENT_DATES: 'The {page} start date and end date must differ.',
  START_DATE_VALID_RANGE:
    'The {page} Start Date must be within the last decade.',
  END_DATE_VALID_RANGE: 'The {page} End Date must be within the last decade.',
  GENERAL_ONSALE_VALID: 'The Onsale Date must be valid.',
  GENERAL_ONSALE_VALID_DECADE:
    'The Onsale Date must be within the last decade.',
  GENERAL_ONSALE_BEFORE_ANNOUNCE:
    'The Onsale Date must be on or after the Announcement Date.',
  GENERAL_ONSALE_AFTER_EVENT: 'The Onsale Date must be before the Event Start.',
};

exports.VisibleOnSiteErrors = {
  VISIBILITY_START_DATE_BEFORE_END_DATE:
    'Visibility On Site Start Date must be before Visible On Sites Start End Date.',
  VISIBILITY_END_DATE_BEFORE_OFFER_END_DATE:
    'Visibility On Site End Date must on or after the Offer End Date.',
};

exports.PresaleErrors = {
  PRESALE_ERROR:
    'The Offer Start and End Dates must be before the Onsale Date.',
};

exports.TemplateErrors = {
  REQUIRED_TEMPLATE_NAME: 'This field is required.',
  DUPLICATE_TEMPLATE_NAME:
    'Template name must not match an existing template name.',
};

exports.RemainingOffersErrors = {
  NO_MORE_ERROR: 'No more associated offers for the template',
};

exports.TicketLinkErrors = {
  DUPLICATE_TICKET_LINK_ERROR:
    'Event already has one offer with this Ticket Link.',
};



// WEBPACK FOOTER //
// ./src/common/constants/errorMessages.js